import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "view", "size", "namespace", "disabled", "text", "textProps", "direction", "classes"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { ButtonBase } from "../internal/ButtonBase";
import { TextBase } from "../internal/TextBase";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import { views } from './constants';
import styles from './RoundButton.css';
var cx = classNames.bind(styles);
export var RoundButton = /*#__PURE__*/forwardRef(function RoundButton(_ref, ref) {
  var children = _ref.children,
      _ref$view = _ref.view,
      view = _ref$view === void 0 ? 'b2c' : _ref$view,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      namespace = _ref.namespace,
      disabled = _ref.disabled,
      text = _ref.text,
      _ref$textProps = _ref.textProps,
      textProps = _ref$textProps === void 0 ? {
    classes: {}
  } : _ref$textProps,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'left' : _ref$direction,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      props = _objectWithoutProperties(_ref, _excluded);

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'roundButton'),
      getTestId = _getMethodsForTestId.getTestId;

  return /*#__PURE__*/React.createElement(ButtonBase, _extends({}, props, {
    className: cx('root', "size_".concat(size), "view_".concat(views[view]), "direction_".concat(direction), classes.root),
    ref: ref,
    disabled: disabled
  }, getTestId()), text && /*#__PURE__*/React.createElement(TextBase, _extends({}, textProps, {
    as: "span",
    color: "inherit",
    weight: "semibold",
    size: "m"
  }), /*#__PURE__*/React.createElement("span", {
    className: cx('text')
  }, text)), /*#__PURE__*/React.createElement("span", {
    className: cx('icon', classes.icon)
  }, children));
});
export default RoundButton;